<script setup lang="ts">
import WidgetRecordAction from '@components/widget/WidgetRecordAction.vue'

const { records, isSelected } = defineProps<{
  records: Array<{ Uuid: string; Name: string; TypeName: string; PersonName: string; PersonEmail: string; PersonPhone: string; GroupNames: string }>,
  isSelected: (uuid: string) => boolean,
}>()

const emit = defineEmits(['set', 'getRecords', 'select', 'unselect', 'isSelected'])

</script>

<template>
  <VTable v-if="records?.length">
    <thead>
      <tr>
        <th>Наименование или ФИО</th>
        <th>Тип</th>
        <th>Контактные данные</th>
        <th>Группы</th>
        <th class="text-center mw-100">
          Действие
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="record in records"
        :key="record.Uuid"
      >
        <!-- Наименование или ФИО -->
        <td>
          <RouterLink
            :to="{ name: 'counterparty', params: { uuid: record.Uuid }, query: { tab: 'preview' } }"
            target="_blank"
          >
            {{ record.Name }}
          </RouterLink>
        </td>

        <!-- Тип -->
        <td>{{ record.TypeName }}</td>

        <!-- Контактные данные -->
        <td>
          <div>{{ record.PersonName }}</div>
          <div>{{ record.PersonEmail }}</div>
          <div>{{ record.PersonPhone }}</div>
        </td>

        <!-- Группы -->
        <td v-html="record.GroupNames" />
        <td class="text-center">
          <WidgetRecordAction
            :selected="isSelected(record.Uuid)"
            @set="emit('select', record)"
            @delete="emit('unselect', record)"
          />
        </td>
      </tr>
    </tbody>
  </VTable>

  <VListItem v-else>
    Нет данных.
  </VListItem>
</template>